import React from 'react'
import AloModal from '../../AloModal'
import { Modal } from 'react-bootstrap'
import PropTypes from 'prop-types'

const ShareError = props => {
  return (
    <AloModal {...props}>
      <Modal.Body>
        You’ve set this playlist to Private. To share, turn off Private under
        the playlist settings.
      </Modal.Body>
      <Modal.Footer>
        <button className='btn alo-button' onClick={props.onHide}>
          Ok
        </button>
      </Modal.Footer>
    </AloModal>
  )
}

ShareError.propTypes = {
  onHide: PropTypes.func
}

export default ShareError
